export default function Assigned(object){
    return object !== null && object !== undefined
}